import styled from 'styled-components';

export const StandardStyled = styled.div`
  /*===============================================
 Container
===============================================*/
  width: 100%;
  overflow: visible;

  .table_scroll_x {
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
  }

  /*===============================================
Theme
===============================================*/
  table {
    border-spacing: 0;
    border: none;
    border-bottom: 0.0625rem solid #eeeeee;
    width: 100%;
    min-width: max-content;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    /* แถวเว้นแถวสีอ่อน ช่วยให้ไล่สายตาตามแถวยาว ๆ ได้ไม่หลุดบรรทัด */
    tbody tr {
      &:nth-child(even) td {
        background: #fafafc;
      }
      &:hover td {
        cursor: pointer;
        background: #f3eefa;
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.875rem 0.875rem;
      border-bottom: 0.0625rem solid #eeeeee;
      vertical-align: middle;
      :last-child {
        border-right: 0;
      }
    }
    .header_group {
      display: flex;
      column-gap: 5px;
    }
    /* หัวตารางมีพื้นหลัง + สีม่วงเข้ม ให้แยกจากเนื้อหาชัด */
    th {
      position: relative;
      padding-right: 1.75rem;
      background: #f4f1f8;
      border-bottom: 0.0625rem solid #e4dcee;
      color: ${({ theme }) => theme.COLORS.PURPLE_4};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      white-space: nowrap;
    }
    /* เดิม 12px Kanit Light สีเทา #737b8b คอนทราสต์ต่ำ อ่านยาก
       ขยายเป็น 14px ตัวปกติ สีเข้มขึ้น (ผ่าน WCAG AA) */
    td {
      color: #3a3f4b;
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      line-height: 1.5;
    }
    .sort {
      position: absolute;
      top: 14px;
      right: 10px;
    }
  }
  .pagi_layout {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    .pagi_info {
      margin-right: auto;
      display: flex;
      align-items: center;
      gap: 24px;
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
    }
    .per_page {
      display: flex;
      align-items: center;
      gap: 10px;
      select {
        cursor: pointer;
        min-width: 72px;
        height: 34px;
        padding: 0 32px 0 12px;
        border: 1px solid ${({ theme }) => theme.COLORS.GRAY_7};
        border-radius: 6px;
        /* ซ่อนลูกศรของ browser แล้ววาดเอง จะได้คุมระยะห่างซ้าย/ขวาได้ */
        appearance: none;
        -webkit-appearance: none;
        background: ${({ theme }) => theme.COLORS.WHITE_1}
          url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%234b1e78' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")
          no-repeat right 12px center;
        color: ${({ theme }) => theme.COLORS.BLACK_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        &:focus {
          outline: none;
          border-color: ${({ theme }) => theme.COLORS.PURPLE_1};
        }
      }
    }
  }

  .table_action_row {
    display: flex;
    .ta_delet_btn {
      padding: 0.25rem 1rem;
      cursor: pointer;
    }
  }
`;
